<template>
<div style="display: flex; margin: -12px;">
    <v-col cols="4" sm="4" md="4">
        <label class="label-modal">Distrito</label>
        <v-autocomplete :items="distritos" :color="$primary" v-model="MyObject.id_distrito" item-text="nome" item-value="id_distrito" @change="changeDistrito(false)"></v-autocomplete>
    </v-col>
    <v-col cols="4" sm="4" md="4">
        <label class="label-modal">Concelho</label>
        <v-autocomplete :items="concelhos" :color="$primary" v-model="MyObject.id_concelho" item-text="nome" item-value="id_concelho" @change="changeConcelho(false)"></v-autocomplete>
    </v-col>
    <v-col cols="4" sm="4" md="4">
        <label class="label-modal">Localidade</label>
        <v-autocomplete :items="localidades" :color="$primary" v-model="MyObject.id_localidade" item-text="nome" item-value="id_localidade"></v-autocomplete>
    </v-col>
</div>
</template>
<script>
import {
    mapState,
    mapActions,
    mapGetters
} from "vuex";
import CRUD from '@/mixins/_CRUD'
export default {
    mixins: [CRUD],
    props: {
        MyObject: Object,
        dialog: Boolean
    },
    data: () => ({
        concelhos: [],
        localidades: []
    }),
    computed: {
        distritos() {
            return this.$store.getters['localidade/getDistritos'];
        }
    },
    watch: {
        dialog(val) {
            if(val) this.init();
        }
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            if(this.MyObject.id_distrito!=null) this.changeDistrito(true);

            setTimeout(() => {
                this.$forceUpdate();
            }, 110);
        },

        changeDistrito(param = false) {
            this.concelhos = [];
            this.localidades = [];
            if(!param) this.MyObject.id_concelho = -1;

            this.$store.dispatch("localidade/getConcelhos", {
                id_distrito: this.MyObject.id_distrito
            }).then((res) => {
                this.concelhos = res ? res : [];

                if(param || (this.concelhos.length == 1 && this.MyObject.id_concelho == -1)) this.changeConcelho(param);
            });
        },

        changeConcelho(param = false) {
            this.localidades = [];
            if(!param) this.MyObject.id_localidade = -1;

            this.$store.dispatch("localidade/getLocalidades", {
                id_concelho: this.MyObject.id_concelho
            }).then((res) => {
                this.localidades = res ? res : [];
            });
        },
    },
}
</script>
